import component from './checkout.component'
import config from './checkout.config'

const module = angular.module('mpa.pages.checkout', [])

module.config(config).component('checkoutPageComponent', component)

export default module.name
